import { reducer as reducer$1 } from "./build/slice.js";
import { reducer as reducer$2 } from "./i18n/slice.js";
import { reducer as reducer$3 } from "./modal-view/slice.js";
import { reducer as reducer$4 } from "./notification/slice.js";
import { reducer as reducer$5 } from "./transient/slice.js";
import { reducer as reducer$6 } from "./view-port/slice.js";
//#region src/redux/reducer.ts
var reducer = {
	build: reducer$1,
	modalView: reducer$3,
	notification: reducer$4,
	viewPort: reducer$6,
	i18n: reducer$2,
	transient: reducer$5
};
//#endregion
export { reducer };

//# sourceMappingURL=reducer.js.map